// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mapCanvasRestList[data-v-41429217] {\n\twidth: 100%;\n\theight: 400px;\n}\n@media only screen and (max-width: 767px) {\n.mapCanvasRestList[data-v-41429217] {\n\t\theight: 350px;\n}\n}\n.orangeTitle[data-v-41429217] {\n\tcolor: #f1560e;\n}\n.mapModalHeader[data-v-41429217] {\n\tfont-size: 25px;\n}\n.mapModalSubmit[data-v-41429217] {\n\tbackground-color: #1783c4;\n\tcolor: #fff;\n\tpadding: 4px;\n}\n.noAddress[data-v-41429217] {\n\tcolor: #f1560f;\n}\n", ""]);
// Exports
module.exports = exports;
